import styled from "styled-components";

export const Container = styled.div`
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 68px;
  padding: 0 16px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

export const ProductName = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const ProductImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;
